<input class="display-none" type="file" accept=".png, .jpg, .jpeg" #avatarInputPic (change)="uploadAvatar($event)">
<ng-container *ngIf="!avatarUrl else elseTemplate1">
  <button (click)="$event.preventDefault()" mat-icon-button (click)="clickOnAvatar()">
    <i class="material-icons">image</i>
  </button>

</ng-container>
<ng-template #elseTemplate1>
  <img [src]='avatarUrl' class="avatar-image" (click)="clickOnAvatar()">
</ng-template>
